import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "@component/dialog";
import { Button } from "@component/button";
import { AlertTriangleIcon } from "lucide-react";

interface AssessmentWarningDialogProps {
    isOpen: boolean;
    onClose: () => void;
    ineligibleCount: number;
}

export default function AssessmentWarningDialog({
    isOpen,
    onClose,
    ineligibleCount,
}: AssessmentWarningDialogProps) {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <div className="flex items-center gap-3 mb-2">
                        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-amber-100 dark:bg-amber-900/30">
                            <AlertTriangleIcon className="w-5 h-5 text-amber-600 dark:text-amber-400" />
                        </div>
                        <DialogTitle className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                            Some candidates weren't moved
                        </DialogTitle>
                    </div>
                    <DialogDescription className="text-sm text-gray-600 dark:text-gray-400 pt-2">
                        <strong className="font-semibold">
                            {ineligibleCount} selected candidate
                            {ineligibleCount !== 1 ? "s" : ""}
                        </strong>{" "}
                        {ineligibleCount === 1 ? "hasn't" : "haven't"} completed the
                        required screening, so they can't be moved to the{" "}
                        <strong className="font-semibold">Needs Review</strong> stage yet.
                        <br />
                        <br />
                        You can move them once their screening is complete.
                    </DialogDescription>
                </DialogHeader>
                <div className="flex justify-end pt-4">
                    <Button
                        onClick={onClose}
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                    >
                        Continue
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
